import { apiClient } from './api-client';

export interface TenantUser {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  username: string | null;
}

export const usersService = {
  listAll: (): Promise<TenantUser[]> =>
    apiClient.get<TenantUser[]>('/auth/users').then((r) => r.data),
};
